export const TIMELIST_SEARCH = 'TIMELIST_SEARCH';
export const TIMELIST_PAGE = 'TIMELIST_PAGE';
export const TIMELIST_WEEK = 'TIMELIST_WEEK';
export const TIMELIST_YEAR = 'TIMELIST_YEAR';
export const TIMELIST_ATTENDANT = 'TIMELIST_ATTENDANT';
export const TIMELIST_STATUS = 'TIMELIST_STATUS';
export const TIMELIST_ACTIVITYLABELID = 'TIMELIST_ACTIVITYLABELID';